import Vue from 'vue'

import './vue/plugins'
import './vue/validator'
import './vue/components'

export const app = new Vue({
  el: '#app'
});

// window.vueEnvInitState = false;

// window.vueEnvInit = function() {

//   if(!window.vueEnvInitState) {

//     new Vue({
//       el: '#app'
//     });

//     window.vueEnvInitState = true;

//   }

// }

// $(document).ready(() => {

//   if($('body').attr('data-page') != 'Home') {

//     window.vueEnvInit();

//   }

// });
